import { useEditor, useNode } from "@craftjs/core";
import ContentEditable from "react-contenteditable";
import Toolbar from "./Toolbar";

interface TextProps {
    text: string;
}

const PageTitle = ({ text }: TextProps) => {
    const {
        connectors: { connect },
        actions: { setProp },
    } = useNode();
    const { enabled } = useEditor((state) => ({ enabled: state.options.enabled }));

    return (
        <div ref={(ref) => connect(ref!)} className="content-center break-words slogan min-w-10">
            <ContentEditable
                html={text || "Title goes here"}
                disabled={!enabled}
                onChange={(e) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setProp((prop: any) => (prop.text = e.target.value), 500);
                }}
                onPaste={(e) => {
                    e.preventDefault();
                    const text = e.clipboardData.getData("text/plain");
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setProp((prop: any) => (prop.text = text), 500);
                }}
                tagName="h1"
                className="break-words"
            />
        </div>
    );
};

PageTitle.craft = {
    displayName: "Title",
    props: {
        text: "Text",
    },
    related: {
        toolbar: Toolbar,
    },
};

export default PageTitle;
